import React from "react";
import styled from "styled-components";
import TextColorControls from "../molecules/TextColorControls";
import TextBackgroundColorControls from "../molecules/TextBackgroundColorControls";
import Xsliders from "../molecules/Xsliders";
import Ysliders from "../molecules/Ysliders";
import BackgroundControl from "../molecules/BackgroundControl";
import {useBoundStore} from "../../stores/useBoundStore";
import {fontFamilies} from "../../utils/fontFamilies";
import {textPositions} from "../../utils/textPositions";

const Holder = styled.div`
  border-radius: 1rem;

  .textRow {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .slidersRow {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  .colorRow {
    display: grid;
    grid-template-columns: 5rem 5rem 5rem 1fr;
    gap: 2rem;
  }
  
  .notice {
    ${(props) => props.theme.fluidType(-2)};
  }
`;

const ApplicationForm = () => {
  const {
    setTextTop,
    setTextBottom,
    textTop,
    textBottom,
    textPosition,
    setTextPosition,
    setFontFamily,
    fontFamily,
    animation,
    setAnimation,
  } = useBoundStore((state) => state);

  return (
    <Holder>

      <div className="textRow">
        <fieldset>
          <label htmlFor="text-top-input">Text top</label>
          <input type="text" placeholder={textTop} id="text-top-input"
                 onChange={(e) => setTextTop(e.target.value)} />
        </fieldset>
        <fieldset>
          <label htmlFor="font-family">Typeface</label>
          <div className="select-holder">
            <select id="font-family" onChange={(e => setFontFamily(fontFamilies[e.target.value]))}
                    defaultValue={fontFamily.id}>
              {fontFamilies.map((font, i) => (
                <option key={i} value={i}>
                  {font}
                </option>
              ))}
            </select>
          </div>
        </fieldset>
        <fieldset>
          <label htmlFor="text-bottom-input">Text bottom</label>
          <input type="text" placeholder={textBottom} id="text-bottom-input"
                 onChange={(e) => setTextBottom(e.target.value)} />
        </fieldset>
        <fieldset>
          <label htmlFor="text-position">Type position</label>
          <div className="select-holder">
            <select id="text-position" onChange={(e => setTextPosition(textPositions[e.target.value]))}
                    defaultValue={textPosition.id}>
              {textPositions.map((position, i) => (
                <option key={i} value={i}>
                  {position}
                </option>
              ))}
            </select>
          </div>
        </fieldset>
        <fieldset>
          <label htmlFor="animation">Animation*</label>
          <div className="select-holder">
            <select id="animation" onChange={(e) => setAnimation(e.target.value)}>
              <option value="noAnimation">None</option>
              <option value="animateX">X</option>
              <option value="animateY">Y</option>
              <option value="animateXY">X and Y</option>
            </select>
          </div>
        </fieldset>
        <p className="notice"><sup>*</sup>We are working on the half pixel gaps in the patterns when using animations. In the meantime we find firefox the best for this issue.</p>
      </div>

      {animation === "noAnimation" && <div className="slidersRow">
        <form>
          <Xsliders />
        </form>
        <form>
          <Ysliders />
        </form>
      </div>}

      <div className="colorRow">
        <BackgroundControl />
        <TextColorControls />
        <TextBackgroundColorControls />
      </div>
    </Holder>
  );
};

export default ApplicationForm;
